import { STRING_getInstance2ou4lro9xn2qn as STRING_getInstance } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialKinds.mjs';
import { PrimitiveSerialDescriptor3egfp53lutxj2 as PrimitiveSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/descriptors/SerialDescriptors.mjs';
import {
  Companion_instance25i2l13l26m9w as Companion_instance,
  DatePeriod2y4m7pf19ebgd as DatePeriod,
  DateTimePeriod384alsehm5scz as DateTimePeriod,
} from '../DateTimePeriod.mjs';
import { SerializationExceptioneqrdve3ts2n9 as SerializationException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var DatePeriodIso8601SerializerClass;
function DatePeriodIso8601Serializer() {
  if (DatePeriodIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        DatePeriodIso8601Serializer_instance = this;
        this.r24_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DatePeriod', STRING_getInstance());
      }
      az() {
        return this.r24_1;
      }
      pz(decoder) {
        var period = Companion_instance.xw(decoder.h13());
        var tmp;
        if (period instanceof DatePeriod()) {
          tmp = period;
        } else {
          throw SerializationException().p10(period.toString() + ' is not a date-based period');
        }
        return tmp;
      }
      s24(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.s24(encoder, value instanceof DatePeriod() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DatePeriodIso8601Serializer', VOID, VOID, [KSerializer()]);
    DatePeriodIso8601SerializerClass = $;
  }
  return DatePeriodIso8601SerializerClass;
}
var DatePeriodIso8601Serializer_instance;
function DatePeriodIso8601Serializer_getInstance() {
  if (DatePeriodIso8601Serializer_instance === VOID)
    new (DatePeriodIso8601Serializer())();
  return DatePeriodIso8601Serializer_instance;
}
var DateTimePeriodIso8601SerializerClass;
function DateTimePeriodIso8601Serializer() {
  if (DateTimePeriodIso8601SerializerClass === VOID) {
    class $ {
      constructor() {
        DateTimePeriodIso8601Serializer_instance = this;
        this.t24_1 = PrimitiveSerialDescriptor('kotlinx.datetime.DateTimePeriod', STRING_getInstance());
      }
      az() {
        return this.t24_1;
      }
      pz(decoder) {
        return Companion_instance.xw(decoder.h13());
      }
      u24(encoder, value) {
        encoder.p14(value.toString());
      }
      oz(encoder, value) {
        return this.u24(encoder, value instanceof DateTimePeriod() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'DateTimePeriodIso8601Serializer', VOID, VOID, [KSerializer()]);
    DateTimePeriodIso8601SerializerClass = $;
  }
  return DateTimePeriodIso8601SerializerClass;
}
var DateTimePeriodIso8601Serializer_instance;
function DateTimePeriodIso8601Serializer_getInstance() {
  if (DateTimePeriodIso8601Serializer_instance === VOID)
    new (DateTimePeriodIso8601Serializer())();
  return DateTimePeriodIso8601Serializer_instance;
}
//region block: exports
export {
  DatePeriodIso8601Serializer_getInstance as DatePeriodIso8601Serializer_getInstance3tqarj6t2b239,
  DateTimePeriodIso8601Serializer_getInstance as DateTimePeriodIso8601Serializer_getInstance11d5fmywzvhi9,
};
//endregion

//# sourceMappingURL=DateTimePeriodSerializers.mjs.map
